import useRouter from "hooks/useRouter";
import React, { createContext, FC, useState, ReactNode, useEffect } from "react";

/**
 * @desc
 * scope = login.tsx
 * This component is just to switch the scene in the login page.
 * For example, forget the password, force a password change,
 * bind Multi-factor authenication Qrcode, etc.
 */
export interface LoginSetting {
    currStep:
        | "LOGIN"
        | "NEW_PASSWORD_REQUIRED"
        | "MFA_SETUP"
        | "SOFTWARE_TOKEN_MFA"
        | "SEND_RESET_PASSWORD_LINK"
        | "RESET_PASSWORD";
    currEmail: string;
}

interface SettingsProviderProps {
    children?: ReactNode;
}

export interface LoginSettingsContextValue {
    settings: LoginSetting;
    saveSettings: React.Dispatch<React.SetStateAction<LoginSetting>>;
}

const initialSettings: LoginSetting = {
    currStep: "LOGIN",
    currEmail: ""
};

const LoginSettingsContext = createContext<LoginSettingsContextValue>({
    settings: initialSettings,
    saveSettings: () => {}
});

export const LoginSettingsProvider: FC<SettingsProviderProps> = props => {
    const { children } = props;
    const [settings, setSettings] = useState<LoginSetting>(initialSettings);
    const router = useRouter();

    useEffect(() => {
        if (router.query.verification && settings.currStep === "LOGIN") {
            setSettings({
                ...settings,
                currStep: "RESET_PASSWORD"
            });
        }
    }, [router.query, settings]);

    return (
        <LoginSettingsContext.Provider
            value={{
                settings,
                saveSettings: setSettings
            }}>
            {children}
        </LoginSettingsContext.Provider>
    );
};

export const LoginSettingsConsumer = LoginSettingsContext.Consumer;

export default LoginSettingsContext;
